module.exports = __webpack_public_path__ + "img/register-illustration.855a501e.svg";